import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        const u = res.data.user;
        setUser(u);
        window.history.replaceState(null, "", window.location.pathname);
        if (!u.role || !u.onboarded) navigate("/onboarding", { state: { user: u } });
        else if (u.role === "super_admin" || u.role === "staff") navigate("/admin", { state: { user: u } });
        else if (u.role === "vendor") navigate("/vendor", { state: { user: u } });
        else if (u.role === "expert") navigate("/expert", { state: { user: u } });
        else if (u.role === "society_member") navigate("/resident", { state: { user: u } });
        else navigate("/app", { state: { user: u } });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 2000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin text-primary mx-auto mb-4" />
        <p className="text-muted-foreground">{error || "Signing you in..."}</p>
      </div>
    </div>
  );
}
